<template>
  <q-page class="q-pl-lg q-pr-lg">
    <q-scroll-area style="height: 100vh;" >
      <h3>Public Components</h3>
        <div class="q-pl-lg q-pr-lg">
          <q-table
            hide-bottom
            title="Public Components"
            :data="serverData"
            :filter="filter"
            :columns="columns"
            :pagination.sync="serverPagination"
            :loading="loading"
            row-key="id"
            @request="request">
            <template slot="top-left" slot-scope="props">
              <q-search
                hide-underline
                color="secondary"
                v-model="filter"
                class="col-6"
              />
            </template>
            <!--<div slot="top" slot-scope="props" class="row flex-center fit">-->
              <!--<div class="on-left">Components</div>-->
              <!--<q-btn class="float-right" @click="addNewComponent">Add New</q-btn>-->
            <!--</div>-->
            <q-td slot="body-cell-publisher" slot-scope="props" :props="props" >
              <router-link class="item item-link" :to="'/users/' + props.row.publisher">
                @{{props.row.publisher}}
              </router-link>
            </q-td>
            <q-td slot="body-cell-actions" slot-scope="props" :props="props" >
              <q-btn
                dense
                flat
                icon="mdi-eye"
                @click="$router.push('/public-components/' + props.row.id)">
                <q-tooltip :offset="[0, 10]">View</q-tooltip>
              </q-btn>
              <q-btn
                dense
                flat
                icon="mdi-content-save"
                :disabled="componentInstalled(props.row)"
                @click="installComponent(props.row)">
                <q-tooltip :offset="[0, 10]">Install</q-tooltip>
              </q-btn>
              <q-btn
                dense
                flat
                icon="file_download"
                @click="downloadComponent(props.row)">
                <q-tooltip :offset="[0, 10]">Download</q-tooltip>
              </q-btn>
            </q-td>
          </q-table>
        </div>
    </q-scroll-area>
  </q-page>
</template>

<script>
import firestore from '../store/firestore'

export default {
  // name: 'PageName',
  data () {
    return {
      filter: '',
      loading: false,
      serverData: [],
      serverPagination: {
        page: 1,
        rowsNumber: 5 // specifying this determines pagination is server-side
      },
      columns: [
        {
          name: 'name',
          required: true,
          label: 'Name',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'publisher',
          required: true,
          label: 'Author',
          align: 'left',
          field: 'publisher',
          sortable: true
        },
        {
          name: 'actions',
          required: true,
          label: 'Actions',
          align: 'center',
          field: null,
          sortable: false
        }
      ]
    }
  },
  computed: {
    components () { return this.$store.getters.getComponentsAsAry }
  },
  methods: {
    request ({ pagination, filter }) {
      // we set QTable to "loading" state
      this.loading = true

      firestore.functions().httpsCallable('publicComponents')({
        page: pagination.page,
        orderBy: pagination.sortBy,
        descending: pagination.descending,
        filter: filter
      }).then(({ data }) => {
        // updating pagination to reflect in the UI
        this.serverPagination = pagination

        // we also set (or update) rowsNumber
        this.serverPagination.rowsNumber = data.rowsNumber

        // then we update the rows with the fetched ones
        this.serverData = data.rows

        // finally we tell QTable to exit the "loading" state
        this.loading = false
      }).catch(error => {
        this.$q.notify({
          message: 'Error fetching data. ' + error,
          type: 'negative'
        })
        // we tell QTable to exit the "loading" state
        this.loading = false
      })
    },
    updateComponentEnabled (v) {
      this.$store.dispatch('updateComponent', v.row)
    },
    componentInstalled (row) {
      const installed = Object.values(this.$store.state.components.components).some(comp => {
        return (comp.publishedId && comp.publishedId === row.id)
      })
      console.log(installed)
      return installed
    },
    installComponent (row) {
      console.log('install public component with id: ' + row.id)
      firestore.db.collection('publicComponents').doc(row.id).get().then(publishedComponent => {
        let installedComp = publishedComponent.data()
        installedComp.publishedId = row.id
        this.$store.dispatch('addComponent', installedComp)
      })
    },
    deleteComponent (row) {
      this.$q.dialog({
        title: 'Delete Component ?',
        message: 'Are you sure you want to delete the component named \'' + row.name + '\'?',
        ok: true,
        cancel: true,
        position: 'top'
      }).then(() => {
        return this.$store.dispatch('deleteComponentWithId', row.id)
      })
    },
    downloadComponent (row) {
    },
    publish (component) {
      firestore.functions().httpsCallable('publishComponent')({ componentId: component.id }).then((result) => {
        this.$q.notify({
          message: 'Published Component!',
          type: 'positive'
        })
      }).catch((err) => {
        this.$q.notify({
          message: 'Could not publish component. ' + err,
          type: 'negative'
        })
      })
    },
    publishComponent (row) {
      let vm = this
      let p = Promise.resolve(null)
      if (!row.publishedId) {
        p = vm.$q.dialog({
          title: 'Publish',
          message: 'Do you want to publish this component?',
          ok: true,
          cancel: true
        }).then(() => {
          return this.publish(row)
        })
      }
      p.then(() => {
        return vm.$q.dialog({
          title: 'Component Published',
          message: 'id = ' + row.publishedId,
          cancel: 'Ok',
          ok: 'Delete!'
        })
      }).then(() => {
        return vm.$q.dialog({
          title: 'Delete',
          message: 'Are you sure you want to un-publish this note?' +
          'Others will then be unable to view it',
          ok: 'Delete',
          cancel: true
        })
      }).then((cancelled) => {
        if (cancelled) return
        vm.noteHelper.unpublish().catch((ex) => {
          vm.$q.notify('Unable to unpublish.')
          console.log(ex)
        })
      })
    },
    addNewComponent () {
      this.$store.dispatch('addComponent', null)
    }
  },
  mounted () {
    this.request({
      pagination: this.serverPagination,
      filter: this.filter
    })
  }
}
</script>

<style>
</style>
